import { BetsApiClient } from "./BettingGatewayClient/BetsApiClient";
import { BettingGatewayConfigurations } from "./BettingGatewayConfigurations";
import { AjaxService } from "sb-helpers";
import { GlobalConfig } from "../configuration";
export class BettingGateway {
    constructor() {
        let config = new BettingGatewayConfigurations({
            accessToken: GlobalConfig
                .getAuthorization()
                .token,
            basePath: GlobalConfig.apiConfigs.betsApiUrl
        });
        let service = new AjaxService();
        this.betsApiClient = new BetsApiClient(config, service);
    }
    getGlobalConfigToken() {
        return GlobalConfig
            .getAuthorization()
            .token;
    }
    placeBets(request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .placeBets(request);
    }
    calculateBets(request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .calculateBets(request);
    }
    precalculateBets(request) {
        return this.betsApiClient
            .refreshToken(this.getGlobalConfigToken())
            .precalculateBets(request);
    }
}
//# sourceMappingURL=BettingGateway.js.map